import {defineAsyncComponent} from 'vue';

const PopupRevenueBusinessChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/PopupRevenueBusinessChart.vue'),
);
const PopupExpenseBusinessChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/PopupExpenseBusinessChart.vue'),
);
const PopupFeeIncomeChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/PopupFeeIncomeChart.vue'));
const PopupFeeExpenseChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/PopupFeeExpenseChart.vue'));
const PopupBudgetExpenseChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/PopupBudgetExpenseChart.vue'),
);
const PopupExpandedChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/PopupExpandedChart.vue'),
);
//CQSN
const PopupRevenueBusinessCQSNChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/cqsn/PopupRevenueBusinessCQSNChart.vue'),
);
const PopupExpenseBusinessCQSNChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/cqsn/PopupExpenseBusinessCQSNChart.vue'),
);
const PopupFeeIncomeCQSNChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/cqsn/PopupFeeIncomeCQSNChart.vue'));
const PopupFeeExpenseCQSNChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/cqsn/PopupFeeExpenseCQSNChart.vue'));
const PopupBudgetExpenseCQSNChart = defineAsyncComponent(() =>
  import('@/views/tracking/popup/cqsn/PopupBudgetExpenseCQSNChart.vue'),
);


const TrackingImplementationDetailDVCQSN = defineAsyncComponent(() => import('@/views/implementationTrackingCQSN/TrackingImplementationDetailDVCQSN.vue'));

export function popupTrackingRegister(app) {
  app.component('PopupRevenueBusinessChart', PopupRevenueBusinessChart);
  app.component('PopupExpenseBusinessChart', PopupExpenseBusinessChart);
  app.component('PopupFeeIncomeChart', PopupFeeIncomeChart);
  app.component('PopupFeeExpenseChart', PopupFeeExpenseChart);
  app.component('PopupBudgetExpenseChart', PopupBudgetExpenseChart);
  app.component('PopupExpandedChart', PopupExpandedChart);
  //CQSN
  app.component('PopupRevenueBusinessCQSNChart', PopupRevenueBusinessCQSNChart);
  app.component('PopupExpenseBusinessCQSNChart', PopupExpenseBusinessCQSNChart);
  app.component('PopupFeeIncomeCQSNChart', PopupFeeIncomeCQSNChart);
  app.component('PopupFeeExpenseCQSNChart', PopupFeeExpenseCQSNChart);
  app.component('PopupBudgetExpenseCQSNChart', PopupBudgetExpenseCQSNChart);
  app.component('TrackingImplementationDetailDVCQSN', TrackingImplementationDetailDVCQSN);
};
